module.exports = __webpack_public_path__ + "media/components/src/assets/images/recruits/block_recruit_1-ed0f2c449d4b6142aaa84dcccd1747fa.jpg";